<template>
	<div>
		<div class="data44">
			<div class="data44Til">
				<div>
					{{list.data.menuTitle}}
				</div>
			</div>
			<div class="data44Box">
				<div class="swiper-hexin" :class="`swiper-hexin${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide swiper-slideTwo" v-for="(itema,indexa) in list.data.content"
							:key="indexa" @click="goJump(item)">
							<div class="swiper-slideTwo-img">
								<img :src="itema.cover" />
							</div>
							<div class="swiper-slideTwo-cen">
								{{itema.title}}
							</div>
						</div>
					</div>
					<template v-if="headerShow">
						<div class="swiper-hexin-prev" v-if="list.data.content.length>2" :style="{
						display:prev,
						left:(bj+30)+'px'
					}">
							<img src="@/assets/product/page6/zjt.png" />
						</div>
						<div class="swiper-hexin-next" v-if="list.data.content.length>2" :style="{
						display:next,
						right:(bj+30)+'px'
					}">
							<img src="@/assets/product/page6/yjt.png" />
						</div>
					</template>
					<template v-else>
						<div class="swiper-hexin-prev" v-if="list.data.content.length>1" :style="{
						display:prev,
						left:'30px'
					}">
							<img src="@/assets/product/page6/zjt.png" />
						</div>
						<div class="swiper-hexin-next" v-if="list.data.content.length>1" :style="{
						display:next,
						right:'30px'
					}">
							<img src="@/assets/product/page6/yjt.png" />
						</div>
					</template>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				// list: [{
				// 		img: require("@/assets/content/hexinBanner.png"),
				// 		imgTwo: require("@/assets/product/page11/tbcd.png"),
				// 		name: '同步传导',
				// 		cen: '结肠镜插入部的惯性设计将手柄处操作者的推拉力和旋转力传递到结肠镜的先端部，能够帮助医生更好地进镜到盲肠'
				// 	},
				// 	{
				// 		img: require("@/assets/content/hexinBanner.png"),
				// 		imgTwo: require("@/assets/product/page11/rykt.png"),
				// 		name: '软硬可调',
				// 		cen: '结肠镜插入管具有多级软硬度调整功能，通过旋转调节环可改变插入部的软硬度，可满足结肠不同部位的进镜需求'
				// 	},
				// 	{
				// 		img: require("@/assets/content/hexinBanner.png"),
				// 		imgTwo: require("@/assets/product/page11/rykt.png"),
				// 		name: '随动弯曲',
				// 		cen: '可顺应结肠不同部位的转向，在脾曲肝曲等部位'
				// 	},
				// 	{
				// 		img: require("@/assets/content/hexinBanner.png"),
				// 		imgTwo: require("@/assets/product/page11/zmxt.png"),
				// 		name: '头端3光窗照明系统',
				// 		cen: '- 提供角度更大、更均匀的照明效果- 与大视场角结合可得到更好的图像效果'
				// 	},
				// 	{
				// 		img: require("@/assets/content/hexinBanner.png"),
				// 		imgTwo: require("@/assets/product/page11/fss.png"),
				// 		name: '副送水',
				// 		cen: '- AQ-300系列全线内镜均配备前向副送水功能- 帮助在诊断和治疗过程中实时保持视野清晰，快速发现出血点'
				// 	},
				// ],
				mySwiper: "",
				sliact: 0,
				prev: 'none',
				next: 'block',
				bj: ""
			}
		},
		watch: {
			bj() {
				let t = this;
				let index = t.list.data.content.length - 2;
				this.sliact = index - 1;
				console.log(index)
				let name = '.swiper-hexin' + this.list.index;
				this.mySwiper = new this.$swiper(name, {
					// 内部Swiper的选项
					direction: 'horizontal',
					widch: 580,
					slidesPerView: 'auto', // 每屏显示3个滑块
					spaceBetween: 40,
					slidesOffsetBefore: this.bj,
					slidesOffsetAfter: this.bj,
					initialSlide: index,
					autoplay: false,
					// 自动播放
					// autoplay: {
					// 	delay: 3000,
					// 	disableOnInteraction: false,
					// },
					navigation: {
						prevEl: ".swiper-hexin-prev",
						nextEl: ".swiper-hexin-next",
					},
					allowTouchMove: this.list.data.content.length > 1 ? true : false,
					on: {
						slideChangeTransitionEnd: function() {
							if (this.activeIndex === 0) {
								t.prev = 'none';
							} else {
								t.prev = 'block';
							}
							if (this.activeIndex === this.slides.length - 1) {
								t.next = 'none';
							} else {
								t.next = 'block';
							}
							if(this.headerShow){
								if (this.activeIndex === this.slides.length - 2) {
									t.next = 'none';
								} else {
									t.next = 'block';
								}
							}
							
							// if (t.sliact == this.activeIndex && t.sliact == this.slides.length - 2) {
							// 	t.next = 'none';
							// } else {
							// 	t.sliact = this.activeIndex;
							// }
						},

					},

				});
			}
		},
		mounted() {
			this.getWidth()

			// t.mySwiper.slideTo(index);
			// t.mySwiper.on('init',function(){
			// 	t.mySwiper.slideTo(index);
			// })
		},
		methods: {
			getWidth() {
				console.log(document.body.clientWidth, window.screen.availWidth)
				let width = ''
				if (document.body.clientWidth > 1200) {
					width = document.body.clientWidth - 1200;
				} else {
					width = 0;
				}
				this.$nextTick(function() {
					this.bj = width / 2
				})
			},
			goJump(e) {
				let url = e.jump_url;
				if (url.indexOf('http') != -1) {
					window.open(url, '_blank')
				} else {
					this.$router.push({
						path: url || '/null',
					})
				}
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.swiper-hexin {
		overflow: hidden;
		position: relative;

		.swiper-hexin-prev {
			position: absolute;
			top: 240px;
			left: 260px;
			z-index: 99;
			width: 51px;
			height: 51px;
			cursor: pointer;

			img {
				width: 51px;
				height: 51px;
			}

			border-radius: 100%;
			transform: translateY(-50%);
			transition: all 0.3s ease;

		}

		.swiper-hexin-next {
			transform: translateY(-50%);
			position: absolute;
			top: 240px;
			right: 260px;
			z-index: 99;
			width: 51px;
			height: 51px;
			border-radius: 100%;
			transition: all 0.3s ease;
			cursor: pointer;

			img {
				width: 51px;
				height: 51px;
			}
		}
	}

	.swiper-slideTwo {
		position: relative;

		width: 580px;

		.swiper-slideTwo-img {
			width: 580px;
			height: 440px;
			margin-bottom: 36px;

			img {
				width: 100%;
				height: 440px;
				object-fit: cover;
			}
		}

		.swiper-slideTwo-imgTwo {
			width: 70px;
			height: 70px;
			margin-bottom: 40px;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.swiper-slideTwo-name {
			font-size: 26px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #000000;
			margin-bottom: 32px;
		}

		.swiper-slideTwo-cen {
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #000000;
		}
	}

	.data44 {
		padding-bottom: 150px;

		.data44Til {
			display: flex;
			// justify-content: end;
			// padding-right: 250px;
			margin: 0 auto 62px;
			width: 1200px;

			>div {
				font-size: 45px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #000000;
				text-align: left;
				// width: 770px;
			}
		}

		.data44Cen {
			display: flex;
			justify-content: end;
			padding-right: 250px;

			>div {
				text-align: left;
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 300;
				color: #000000;
				width: 770px;
			}

			margin-bottom: 65px;
		}

		.data44Img {
			padding-right: 250px;
			width: 100%;
			height: 600px;
			box-sizing: border-box;
			margin-bottom: 40px;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.data44Box {}
	}

	@media screen and (max-width:1200px) {
		.swiper-slide {
			width: 100% !important;
		}

		.swiper-slideTwo {
			width: 100% !important;

			.swiper-slideTwo-img {
				width: 100% !important;
				height: auto !important;
				margin-bottom: 20px !important;

				img {
					height: auto !important;
					object-fit: contain !important;
				}
			}

			.swiper-slideTwo-imgTwo {
				width: 35px !important;
				height: 35px !important;
				margin-bottom: 20px !important;
			}

			.swiper-slideTwo-name {
				font-size: 18px !important;
			}

			.swiper-slideTwo-cen {
				font-size: 14px !important;
			}
		}

		.data44 {
			width: 100% !important;
			padding: 0 30px 30px !important;
			box-sizing: border-box;

			.data44Til {
				padding-left: 0px !important;
				font-size: 24px !important;
				margin-bottom: 20px !important;
				width: 100% !important;

				>div {
					font-size: 24px !important;
				}
			}

			.data44Cen {
				padding-left: 0px !important;
				font-size: 14px !important;
				margin-bottom: 20px !important;
				width: 100% !important;
			}

			.data44Img {
				padding-left: 0px !important;
				height: auto !important;
				margin-bottom: 20px !important;

				img {
					height: auto !important;
				}
			}
		}

		// .swiper-hexin-next {
		// 	display: none !important;
		// }

		// .swiper-hexin-prev {
		// 	display: none !important;
		// }
	}
</style>